<script>
  import { onMount } from 'svelte';
  import CurrencyInput from './CurrencyInput.svelte';
//  import { Popover } from 'svelte-smooth-popover';
  import Slider from 'svelte-range-slider-pips';
  import 'svelte-range-slider-pips/dist/styles.css';
  export let utd;
  export let jackpot;
  export let revenue;
  export let insats;
  export let activeGame;

  let stepSmall = 100;
  let stepMedium = 1000;
  let stepLarge = 100000;
  let jpLabel = "Jackpot";

$: {
  if (activeGame === 'stryktipset') {
    stepSmall = 100;
    stepMedium = 1000;
    stepLarge = 1000000;
    // revenue = 25000000;
  }
  if (activeGame === 'europatipset') {
    stepSmall = 100;
    stepMedium = 1000;
    stepLarge = 1000000;
    // revenue = 10000000;
  } 
  if (activeGame === 'topptipset') {
    stepSmall = 100;
    stepMedium = 1000;
    stepLarge = 1000000;
    // revenue = 1000000;
    jpLabel = "Extrapengar";
  }
  if (activeGame === 'powerplay') {
    stepSmall = 100;
    stepMedium = 1000;
    stepLarge = 1000000;
    // revenue = 1000000;
    jpLabel = "Extrapengar";
  }  
}

</script>

<div class="tab-content revenue">

  <div class="buttonGroup">

    <div class="numberPills">
      
    <div class="numberButtonPill pill-1">

      <CurrencyInput 
        bind:value={utd[1]}
        label="Utdelning Min"
        min={0}
        max={100000000}
        stepSmall={stepSmall}
        stepMedium={stepMedium}
        stepLarge={stepLarge}
      />

    </div>
  </div>

    <div class="numberPills">

    <div class="numberButtonPill pill-1">

      <CurrencyInput 
        bind:value={utd[2]}
        label="Utdelning Max"
        min={0}
        max={100000000}
        stepSmall={stepSmall}
        stepMedium={stepMedium}
        stepLarge={stepLarge}
      />

    </div>
  </div>
  </div>

<!-- Oms och jackpot -->

  <div class="buttonGroup">

    <div class="numberPills">

    <div class="numberButtonPill pill-1">

      <CurrencyInput 
        bind:value={revenue}
        label="Omsättning"
        min={0}
        max={100000000}
        stepSmall={stepSmall}
        stepMedium={stepMedium}
        stepLarge={stepLarge}
      />

    </div>
  </div>

    <div class="numberPills">
    <div class="numberButtonPill pill-1">

      <CurrencyInput 
        bind:value={jackpot}
        label={jpLabel}
        min={0}
        max={100000000}
        stepSmall={stepSmall}
        stepMedium={stepMedium}
        stepLarge={stepLarge}
      />
    </div>
      </div>

  </div>

{#if (activeGame === 'topptipset' || activeGame === 'powerplay' )}
  <label>Insats per rad</label>
<div class="buttonGroup">
    <div class="slider slider-1">
              <Slider
                range={false}
                min={1}
                max={10}
                step={1}
                suffix=" kr"
                float={false}
                hoverable={true}
                disabled={false}
                pushy
                pips
                all="label"
                bind:values={insats}
              />
            </div>
  </div>
{/if}


<!-- Slut -->

</div>

<!-- Oms + jackpot -->



<style>
  .scroll-container-wrapper {
    position: relative;
    overflow: hidden;
  }

  .scroll-container {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 0;
    scrollbar-width: none;  /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
  }

  .scroll-container::-webkit-scrollbar {
    display: none;  /* WebKit */
  }

  .end-padding {
    flex-shrink: 0;
    width: 4px;  /* Half the container width minus half a button width */
    min-width: 5px;  /* Minimum padding */
  }

  .left-indicator,
  .right-indicator {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 30px;
    pointer-events: none;
    z-index: 1;
  }

  .left-indicator {
    left: 0;
    background: linear-gradient(to right, var(--themeColor1), rgba(255,255,255,0));
  }

  .right-indicator {
    right: 0;
    background: linear-gradient(to left, var(--themeColor1), rgba(255,255,255,0));
  }

  button {
    margin: 0 5px;
    padding: 5px 10px;
    flex-shrink: 0;
  }

  label {
    display: block;
    margin-top: 10px;
    font-weight: 700;
  }

  .buttonGroup {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttonGroup .numberPills {
    flex: 3;
    padding-top: 5pt;
  /*   border: 1px solid yellow; */
    font-size: 14pt;
    font-weight: 700;
  }

  .numberButtonPill {
    display: inline-flex;
    position: relative;
  }

  .numberPills:focused {

  }

  .numberButtonPill, .numberButtonPill * {
    box-sizing: border-box;
  }


  .numberButtonPill.pill-1 button, .numberButtonPill.pill-1 input[type=number] {
    background-color: var(--themeColor1);
    border-color: var(--themeColor1);
    color: white;
    width: 110pt;
  }


  input {
    width: 100px;
  }

.tab-content {
  display: grid;
/*   padding: 0 10pt 0 10pt; */
  grid-template-columns: 1fr; /* Switch to one-column layout */
  justify-content: center;
  align-items: center;
  color: var(--themeColorText);
/*   height: 50pt; */
  transition: height 3s ease-in-out;
/*   overflow: hidden; */
  background: none;
  text-align: center;
    margin: 0;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
/*   border-radius: 15pt; */
/*   border: 3pt solid green; */
}

.popOverInfo {
  background-color: white !important;
  border: 3pt solid white;
  max-width: 200pt;
  padding: 10pt;
  margin: 0;
  border-radius: 10pt;
}

.buttonGroup {
  flex: 1;
  display: flex;
}

.buttonGroup .slider {
  flex: 1;
}

.slider {
  padding-left: 20pt;
  padding-right: 20pt;
}

.buttonGroup .info {
  flex: 1;
  display: grid;
/*   border: 2pt solid red; */
/*   vertical-align: text-top; */
  justify-content: center;
  align-items: center;
}

.slider-1 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #1e90ff; /* inactive handle color */
  --range-handle:          #1e90ff; /* non-focussed handle color */
  --range-handle-focus:    #1e90ff; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}

:root {
  --range-handle-border:   var(--range-handle); /* handle border color */
  --range-range-inactive:  var(--range-handle-inactive); /* inactive range bar background color */
  --range-range:           var(--range-handle-focus); /* active range background color */
  --range-float-inactive:  var(--range-handle-inactive); /* inactive floating label background color */
  --range-float:           var(--range-handle-focus); /* floating label background color */
  --range-float-text:      white; /* text color on floating label */
  --range-pip:                white; /* color of the base pips */
  --range-pip-text:           var(--range-pip); /* color of the base labels */
  --range-pip-active-text:    var(--range-pip-active); /* active labels (when handle is on a slider-stop) */
  --range-pip-hover-text:     var(--range-pip-hover); /* when a slider-stop is hovered */
  --range-pip-in-range:       var(--range-pip-active); /* pips inside the range */
  --range-pip-in-range-text:  var(--range-pip-active-text); /* labels inside the range */
}

.rangeSlider {
  display: inline-flex;
  flex: 7;
  column-gap: 10px;
}

.rangeSlider {
    font-size: 8pt;
  }


    /* Mobile styles */
  @media (max-width: 768px) {

    .buttonGroup .numberPills {
      font-size: 12pt;
    }
 
    .tab-content {
      display: grid;
      padding: 0 0 0 5pt;
    }

    .numberButtonPill.pill-1 button, .numberButtonPill.pill-1 input[type=number] {
      width: 100pt;
    }


    .input-wrapper {
      transform-origin: center left;
    }
    
    .input-wrapper.focused {
      position: absolute;
      width: 200%; /* Double the width */
      background: white; /* Add background to cover content behind */
      z-index: 2;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* Optional: add shadow for depth */
      padding: 0.5rem;
      border-radius: 4px;
    }
    
    /* Container needs relative positioning for absolute positioning to work */
    .input-container {
      position: relative;
      margin: 1rem 0;
    }
  }
  
  /* Optional: Add smooth transitions for all properties */
  .input-field,
  .step-button,
  input,
  .currency-suffix {
    transition: all 0.3s ease-in-out;
  }


</style>